export function formatTitlecase(value?: string) {
  if (!value) return "";

  return value
    .split(" ")
    .map(n => n.trim())
    .map(n => (n ? n[0].toLocaleUpperCase() + n.substring(1).toLocaleLowerCase() : ""))
    .join(" ");
}
